import "./App.css";
import React, { useState } from 'react';
import SideBar from "./components/Sidebar/SideBar";
import TopNavBar from "./components/TopNavBar/TopNavBar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { SiteProvider } from "./context/SiteContext";
import { RoleProvider } from "./context/RoleContext";
import Dashboard from "./pages/Dashboard";
import StpDashboard from "./pages/StpSolution/StpDashboard";
import AqmDashboard from "./pages/AqmSolution/AqmDashboard";
import IrrigationDashboard from "./pages/IrrigationSolution/IrrigationDashboard";
import TreatedWaterDashboard from "./pages/StpSolution/TreatedWaterDashboard";
import Notification from "./pages/Notification";
import ControlUnitStpDetails from "./pages/StpSolution/ControlUnitStpDetails";
import ControlUnitIrrigationDetails from "./pages/IrrigationSolution/ControlUnitIrrigationDetails";
import IrrigationSettings from "./pages/IrrigationSolution/IrrigationSettings";
import AirQualityDetails from "./pages/AqmSolution/AirQualityDetails";
import TreatedWaterDetails from "./pages/StpSolution/TreatedWaterDetails";
import WaterLevelDetails from "./pages/WaterLevelDetails";
import LoraGateway from "./pages/Devices/LoraGateway";
import DeviceList from "./pages/Devices/DeviceList";
import GWSetting from "./pages/Devices/GwSetting";
import UserManagement from "./pages/Users/UserManagement";
import FacilityDashboard from "./pages/FacilityManagement/FacilityDashboard";
import FacilitySettings from "./pages/FacilityManagement/FacilitySettings";
import FleetDashboard from "./pages/FleetManagement/FleetDashboard";
import WaterDashboard from "./pages/WaterManagement/WaterDashboard";
import SiteManagement from "./pages/SiteManagement/SiteManagement";
import OrgManagement from "./pages/OrgManagement/OrgManagement";

const DivStateContext = React.createContext();

function App() {
  const [divState, setDivState] = useState(null);

  return (
    <DivStateContext.Provider value={{ divState, setDivState }}>
      <RoleProvider>
      <SiteProvider>
        <Router>
          {/* Outer column: TopNavBar on top, sidebar+content below */}
          <div className="iomt-app-root">
            <TopNavBar />
            <div className="App">
              <SideBar />
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard/stp" element={<StpDashboard />} />
                <Route path="/dashboard/aqm" element={<AqmDashboard />} />
                <Route path="/dashboard/irrigation" element={<IrrigationDashboard />} />
                <Route path="/dashboard/treated-water" element={<TreatedWaterDashboard />} />
                <Route path="/notification" element={<Notification />} />
                <Route path="/gwsettings" element={<GWSetting />} />
                <Route path="/gwsettings/:gatewayId" element={<GWSetting />} />
                <Route path="/control-unit/:deviceId" element={<ControlUnitStpDetails />} />
                <Route path="/irrigation/:deviceId" element={<ControlUnitIrrigationDetails />} />
                <Route path="/irrigation/:deviceId/settings" element={<IrrigationSettings />} />
                <Route path="/air-quality/:deviceId" element={<AirQualityDetails />} />
                <Route path="/treated-water/:deviceId" element={<TreatedWaterDetails />} />
                <Route path="/water-level/:deviceId" element={<WaterLevelDetails />} />
                <Route path="/lora-gateway/:gatewayId" element={<LoraGateway />} />
                <Route path="/devices" element={<DeviceList />} />
                <Route path="/users" element={<UserManagement />} />
                <Route path="/dashboard/facility" element={<FacilityDashboard />} />
                <Route path="/dashboard/facility/settings" element={<FacilitySettings />} />
                <Route path="/dashboard/fleet" element={<FleetDashboard />} />
                <Route path="/dashboard/water" element={<WaterDashboard />} />
                <Route path="/sites" element={<SiteManagement />} />
                <Route path="/organizations" element={<OrgManagement />} />

                <Route path="*" element={<> not found</>} />
              </Routes>
            </div>
          </div>
        </Router>
      </SiteProvider>
      </RoleProvider>
    </DivStateContext.Provider>
  );
}

export default App;
